<template>
  <div class='reset-pas'>
    <router-link to='/login' class='login'>登录 <i class='el-icon-arrow-right'></i></router-link>
    <div class='reset-form-container'>
      <div class='rest-password'>
        <h2>{{ isNextStep ? '设置新密码' : '验证手机号' }}</h2>
        <div class='hd m-b-15'>
          <div class='item' :class="!isNextStep && 'active'">1</div>
          <div class='line'></div>
          <div class='item' :class="isNextStep && 'active'">2</div>
        </div>
        <el-form :model='restForm' :rules='restRules'>
          <template v-if='!isNextStep'>
            <el-form-item prop='phone'>
              <el-input
                ref='phone'
                v-model.trim='restForm.phone'
                placeholder='请输入绑定的手机号'
                name='phone'
                type='text'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>手机号</template>
              </el-input>
            </el-form-item>
            <el-form-item prop='captcha' class='input-flex-append'>
              <el-input
                ref='captcha'
                v-model.trim='restForm.captcha'
                placeholder='请输入图形验证码'
                name='captcha'
                type='text'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>图形码</template>
              </el-input>
              <img
                @click='resetCap'
                :src='`${baseUrl}/reset/sms_send?t=${captchaTime}`'
                class='captcha'
                width='120px'
              />
            </el-form-item>
            <el-form-item prop='code' class='input-flex-append'>
              <el-input
                ref='code'
                v-model.trim='restForm.code'
                placeholder='请输入短信验证码'
                name='code'
                type='text'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>验证码</template>
              </el-input>
              <el-button
                :disabled='!!sec'
                class='send-sms'
                @click.native='getCode'
              >{{ sec ? `${ sec }s` : '发送验证码' }}
              </el-button>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item prop='newPassword' class='m-b-10'>
              <el-input
                ref='newPassword'
                v-model.trim='restForm.newPassword'
                placeholder='请输入新密码'
                name='newPassword'
                type='password'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>新&ensp;密&ensp;码</template>
              </el-input>
            </el-form-item>
            <el-form-item class='m-b-10'>
              <password-level :password='restForm.newPassword' />
            </el-form-item>
            <el-form-item prop='reNewPassword'>
              <el-input
                ref='reNewPassword'
                v-model.trim='restForm.reNewPassword'
                placeholder='请重新输入新密码'
                name='reNewPassword'
                type='password'
                tabindex='1'
                autocomplete='on'
              >
                <template slot='prepend'>确认密码</template>
              </el-input>
            </el-form-item>
            <PasswordTip ref='passwordTip' :password='restForm.newPassword' />
          </template>
          <el-form-item class='m-t-15'>
            <el-button
              :loading='loading'
              @click='subNewPas'
              v-if='isNextStep'
              class='width-full'
              type='primary'
            >保存
            </el-button>
            <el-button
              :loading='loading'
              v-else
              @click='nextStep'
              class='width-full'
              type='primary'
            >下一步
            </el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
  </div>
</template>
<script>
import { FormItem, Form, Input, Icon } from 'element-ui';
import PasswordLevel from '@/components/PasswordLevel';
import pattern from '@/utils/pattern';
import env from '@/api/env';
import { resetSms, reset } from '@/api';
import PasswordTip from '@/components/passwordTip/index.vue';

export default {
  name: 'ResetPassword',
  components: {
    PasswordTip,
    ElForm: Form,
    ElInput: Input,
    ElFormItem: FormItem,
    ElIcon: Icon,
    PasswordLevel
  },
  data() {
    return {
      baseUrl: env.baseUrl,
      captchaTime: new Date().getTime(),
      loading: false,
      isNextStep: false,
      restForm: {
        phone: '',
        captcha: '',
        code: '',
        newPassword: '',
        reNewPassword: ''
      },
      restRules: {
        phone: [
          {
            required: true,
            message: '请填写正确的手机号',
            trigger: 'blur',
            pattern: pattern.mobile
          }
        ],
        code: [
          {
            required: true,
            message: '请填写正确的手机验证码',
            trigger: 'blur',
            pattern: pattern.smsCode
          }
        ],
        captcha: [
          {
            required: true,
            message: '请填写正确的图形码',
            trigger: 'blur',
            pattern: pattern.captcha
          }
        ]
      },
      MAX_SEC: 60,
      sec: 0,
      timer: ''
    };
  },
  mounted() {
  },
  methods: {
    async nextStep() {
      if (!pattern.mobile.test(this.restForm.phone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.restForm.captcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      const res = await reset({
        params: {
          phone: this.restForm.phone,
          sms_verify_code: this.restForm.code
        },
        methold: 'post'
      });
      if (res) this.isNextStep = true;
    },
    async getCode() {
      if (!pattern.mobile.test(this.restForm.phone)) {
        this.$message.warning('请输入正确的手机号！');
        return;
      }
      if (!pattern.captcha.test(this.restForm.captcha)) {
        this.$message.warning('请输入正确的图形码！');
        return;
      }
      const res = await resetSms({
        img_verify_code: this.restForm.captcha,
        phone: this.restForm.phone
      });
      if (res) {
        if (this.sec === 0) {
          this.sec = this.MAX_SEC;
          this.setTime();
        }
      } else {
        this.resetCap();
      }
    },
    resetCap() {
      this.captchaTime = new Date().getTime();
    },
    setTime() {
      this.sec = this.sec - 1;
      if (this.sec > 0) {
        this.timer = setTimeout(() => {
          this.setTime();
        }, 1000);
      }
    },
    async subNewPas() {
      if (!this.restForm.newPassword) {
        this.$message.warning('请输入新密码！');
        return;
      }
      if (this.restForm.newPassword && this.restForm.newPassword !== this.restForm.reNewPassword) {
        this.$message.warning('两次输入的密码不一致！');
        return;
      }
      if (!this.$refs.passwordTip.runValidate()) {
        return;
      }
      this.loading = true;
      const res = await reset({
        params: {
          new_password: this.restForm.newPassword,
          confirm_new_password: this.restForm.reNewPassword,
          phone: this.restForm.phone
        },
        methold: 'put'
      });
      if (res) {
        this.$message.success(res.msg || '重置密码成功，请登录！');
        this.$router.push('/login');
      }
      this.loading = false;
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.timer);
  }
};
</script>

<style lang='less'>
@bg: #2d3a4b;
.reset-pas {
  position: relative;

  .login {
    position: absolute;
    top: 20px;
    right: 20px;
    color: #017dfc;
    font-size: 18px;
  }
}

.reset-form-container {
  min-height: 100vh;
  width: 100%;
  background: @bg url(../assets/images/login_bg.jpg) no-repeat center;
  background-size: cover;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  .captcha {
    cursor: pointer;
  }

  .el-input {
    display: inline-table;
    height: 47px;

    input {
      background: transparent;
      -webkit-appearance: none;
      border-radius: 0px;
      padding: 12px 5px 12px 15px;
      height: 47px;
    }
  }

  .rest-password {
    width: 500px;
    background: #fff;
    padding: 15px 30px;

    .input-flex-append .el-form-item__content {
      display: flex;

      .el-input {
        flex: 1;
      }

      img {
        margin-left: 10px;
      }

      .send-sms {
        margin-left: 18px;
        width: 112px;
        text-align: center;
      }
    }

    h2 {
      text-align: center;
    }

    .hd {
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;

      .line {
        width: 100px;
        height: 1px;
        border-top: 1px solid #ccc;
      }

      .item {
        margin: 10px 20px;
        border: 1px solid @main-blue;
        width: 50px;
        height: 50px;
        border-radius: 50px;
        display: flex;
        align-items: center;
        justify-content: center;

        &.active {
          color: #fff;
          background: @main-blue;
        }
      }
    }
  }
}

</style>
